import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  Flex,
  FormElement,
  FormLabel,
  INPUT_TEXT_VARIANT_DANGER,
  InputText,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Panel,
  SPACING_24,
  SpacingVertical,
  Toggle
} from 'mailup-web-components'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

const defaultState = {
  name: '',
  notes: '',
  testGroup: false,
  nameIsDirty: false
}

const ModalAddGroup = ({ show, onCancel, onConfirm }) => {
  const intl = useIntl()
  const [{ name, notes, testGroup, nameIsDirty }, setData] =
    useState(defaultState)

  useEffect(() => {
    if (!show) {
      setData(defaultState)
    }
  }, [show])

  const handleChangeName = ({ target: { value } }) => {
    setData((prev) => ({ ...prev, name: value, nameIsDirty: true }))
  }

  const handleChangeNotes = ({ target: { value } }) => {
    setData((prev) => ({ ...prev, notes: value }))
  }

  const handleToggleTestGroup = ({ target: { checked } }) => {
    setData((prev) => ({ ...prev, testGroup: checked }))
  }

  const handleAddGroup = () => {
    onConfirm({ name, notes, testGroup })
  }

  const requiredFeedback = intl.formatMessage({
    id: 'Load.MailupCommon.Required'
  })

  return (
    <Modal show={show} onClose={onCancel} showClose closeOnOverlayClick>
      <ModalHead title={intl.formatMessage({ id: 'Load.NewGroup.Title' })} />
      <ModalBody>
        <FormElement
          label={intl.formatMessage({ id: 'Load.NewGroup.GroupName' })}
          required
          feedback={nameIsDirty && !name ? requiredFeedback : undefined}
          variant={nameIsDirty && !name ? 'danger' : undefined}
        >
          <InputText
            value={name}
            onChange={handleChangeName}
            variant={
              nameIsDirty && !name ? INPUT_TEXT_VARIANT_DANGER : undefined
            }
          />
        </FormElement>

        <SpacingVertical variant={SPACING_24} />

        <FormElement
          label={intl.formatMessage({ id: 'Load.NewGroup.AdminNotes' })}
        >
          <InputText value={notes} onChange={handleChangeNotes} />
        </FormElement>

        <SpacingVertical variant={SPACING_24} />

        <Panel>
          <Flex alignItems='center' justifyContent='space-between'>
            <FormLabel htmlFor='testGroup'>
              {intl.formatMessage({ id: 'Load.NewGroup.CreateTestGroup' })}
            </FormLabel>
            <Toggle
              id='testGroup'
              value
              checked={testGroup}
              onChange={handleToggleTestGroup}
            />
          </Flex>
        </Panel>
      </ModalBody>
      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={handleAddGroup}
          disabled={!name}
        >
          {intl.formatMessage({ id: 'Load.NewGroup.AddGroup' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

ModalAddGroup.propTypes = {
  show: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func
}

export default ModalAddGroup
